import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Input
} from "reactstrap";

import {
  PanelHeader,
  Button
} from "components";
import Select from "react-select";
import { validateSpanishId } from "spain-id";

import moment from "moment";

import { Wheel } from 'react-custom-roulette';

const wheelPrizes = [
  { option: "Primer mes gratis", style: { backgroundColor: '#59C096', textColor: 'white' } },// 0
  { option: 'Descuento de 10€', style: { backgroundColor: 'white', textColor: 'black' } },// 1
  { option: 'iPad Air 64GB', style: { backgroundColor: 'black', textColor: 'white' } }, // 2
  // { option: 'Sombrero', style: { backgroundColor: '#59C096', textColor: 'white' } },//
  { option: 'Refresco/Cerveza', style: { backgroundColor: '#9778b3', textColor: 'black' } },// 3
  { option: 'Amazon Alexa', style: { backgroundColor: '#00A8E1', textColor: 'white' } }, // 4
  { option: 'Regalo seguro', style: { backgroundColor: '#59C096', textColor: 'white' } },// 5
  { option: 'Refresco/Cerveza', style: { backgroundColor: '#9778b3', textColor: 'black' } },// 6
  { option: 'Descuento de 15€', style: { backgroundColor: 'black', textColor: 'white' } },// 7
  // { option: '9', style: { backgroundColor: '#59C096', textColor: 'white' } },
  // { option: '10', style: { backgroundColor: 'white', textColor: 'black' } },
  // { option: '11', style: { backgroundColor: 'black', textColor: 'white' } },
  // { option: '12', style: { backgroundColor: '#59C096', textColor: 'white' } },
  // { option: '13', style: { backgroundColor: 'white', textColor: 'black' } },
  // { option: '14', style: { backgroundColor: 'black', textColor: 'white' } },
];
const interestsList = [
  {
    value: "nada",
    label: "Nada, jaja, era por las risas"
  },
  {
    value: "pack",
    label: "Pack de Internet + Móvil"
  },
  {
    value: "internet",
    label: "Internet en casa"
  },
  {
    value: "movil",
    label: "Móvil"
  }
];
const pass = "ruleta2022";

class Roulette extends React.Component {
  constructor(props) {
    super(props);
    /* //console.log("########## PROPS ###########");
    //console.log(props); */
    this.state = {
      pass: null,
      prizeNumber: 0,
      mustSpin: false,
      waitingResult: false,
      fieldStates: []
    };
    this.handleSpinClick = this.handleSpinClick.bind(this);
    this.handleSpinStop = this.handleSpinStop.bind(this);
    this.getWheel = this.getWheel.bind(this);
    this.onChange = this.onChange.bind(this);
    this.emailChange = this.emailChange.bind(this);
    this.mobileChange = this.mobileChange.bind(this);
    this.validateNumber = this.validateNumber.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.fullnameValidate = this.fullnameValidate.bind(this);
    this.sendForm = this.sendForm.bind(this);
  }
  componentDidMount() {
  }
  validateForm() {
    return (
      this.state.selectedInterest &&
      this.validatePhoneNumber(this.state.mobile) &&
      this.emailValidate(this.state.email) &&
      this.fullnameValidate(this.state.name)
    );
  }
  fullnameValidate(value) {
    let result = false;
    if (value) {
      let chunks = value.split(" ");
      // Comprobamos que haya más de 1 palabra
      if (chunks.length > 1) {
        let subresult = true;
        // Comprobamos que cada palabra tenga más de 1 caracter
        chunks.map(current => {
          subresult = current.length > 1 && subresult;
        });
        result = subresult;
      }
    }
    return result;
  }
  onChange(field, value) {
    let state = this.state;
    state[field] = value;
    this.setState(state);
  }
  emailValidate(email) {
    if (!email) return false;
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRex.test(email);
  }
  emailChange(e) {
    let email = e.target.value;
    this.setState({
      email: email
    });
    if (this.emailValidate(email)) {
      this.setState({
        emailState: " has-success"
      });
    } else {
      this.setState({
        emailState: " has-danger"
      });
    }
    this.onChange("email", e.target.value);
  }
  mobileChange(e) {
    let mobile = e.target.value;
    this.setState({
      mobile: mobile
    });
    if (this.validatePhoneNumber(mobile)) {
      this.setState({
        mobileState: " has-success"
      });
    } else {
      this.setState({
        mobileState: " has-danger"
      });
    }
    this.onChange("mobile", mobile);
  }
  validateNumber(e) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(e)) {
      return true;
    } else {
      return false;
    }
  }
  validatePhoneNumber(phoneNumber) {
    let result = false;
    if (this.validateNumber(phoneNumber)) {
      if (phoneNumber.startsWith("6") || phoneNumber.startsWith("7") || phoneNumber.startsWith("8") || phoneNumber.startsWith("9")) {
        if (phoneNumber.length === 9) {
          result = true;
        }
      }
    }
    return result;
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    switch (field) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "movil":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          if (this.isNewIBAN(value)) {
            this.props.setCustomerIBAN(this.state.customer.id, value);
            this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "newPassword":
        if (this.validateNewPassword(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nombre":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "primer_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "segundo_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "email":
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nif":
        var regPassport = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
        var validPassport = regPassport.test(value);
        if (validateSpanishId(value) || validPassport) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "direccion":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "localidad":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "codigo_postal":
        if (value && value > 0 && value.length === 5) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  handleSpinStop() {
    this.setState({
      mustSpin: false,
      resultReady: true
    });
  }
  handleSpinClick() {
    this.setState({
      waitingResult: true
    });
    // console.log("Solicitando resultado");
    this.props.startWheel().then( response => {
      // console.log("Resultado: ", response);
      this.setState({
        waitingResult: false,
        result: response,
        mustSpin: true,
        prizeNumber: response.result
      });
    });
  }
  sendForm() {
    this.setState({
      sendingForm: true,
      error: null
    });
    let formData = {
      id: this.state.result.id,
      fields: [
        {
          id: "name",
          name: "Nombre",
          value: this.state.name,
          type: "text"
        },
        {
          id: "email",
          name: "Email",
          value: this.state.email,
          type: "text"
        },
        {
          id: "mobile",
          name: "Móvil",
          value: this.state.mobile,
          type: "number"
        },
        {
          id: "interest",
          name: "Interés",
          value: this.state.selectedInterest,
          type: "select"
        }
      ]
    };
    this.props.sendWheelForm(formData).then(response => {
      // console.log("Resultado: ", response);
      let state = this.state;
      state.sendingForm = false;
      if (response.result === "OK") {
        state.name = null;
        state.email = null;
        state.mobile = null;
        state.result = null;
        state.error = null;
        state.selectedInterest = null;
        state.resultReady = false;
        state.lastResult = response.id;
      } else {
        state.error = response.error;
      }
      this.setState(state);
    });
  }
  getWheel() {
    let result = [];

    result.push(
      <Col key="wheel" xs={12} className="wheel-container">
        <Wheel
          mustStartSpinning={this.state.mustSpin}
          prizeNumber={this.state.prizeNumber}
          data={wheelPrizes}
          // backgroundColors={['#FFFFFF', '#59C096', '#000000']}
          // textColors={['#ffffff']}
          innerRadius={20}
          innerBorderWidth={5}
          fontSize={15}
          onStopSpinning={() => {
            this.handleSpinStop();
          }}
        />
      </Col>
    );
    result.push(
      <Col key="wheelButton" xs={12}>
        <Button 
          color={this.state.resultReady ? "primary" : "danger"}
          style={{display: "block", width: "100%", fontSize: "2em"}}
          // size="sm"
          disabled={this.state.mustSpin || this.state.waitingResult || this.state.resultReady}
          onClick={this.handleSpinClick}>
            {this.state.resultReady ? "¡Consulta tu premio!" : (this.state.mustSpin ? <div><i className="now-ui-icons arrows-1_refresh-69 spin" /> Girando...</div> : "¡Jugar!")}
        </Button>
      </Col>
    );

    if (this.state.lastResult && !this.state.resultReady) {
      console.log("ID último resultado: ", this.state.lastResult);
      result.push(
        <Col key="resultHeader" xs={12} className="text-center">
          <h5>Premio anterior <b>#{this.state.lastResult}</b></h5>
        </Col>
      );
    }

    if (this.state.resultReady) {
      console.log("State después del resultado: ", this.state);
      result.push(
        <Col key="resultHeader" xs={12} className="text-center">
          <h4 className="text-center"><b>¡Enhorabuena!</b></h4>
          <h5>Rellena el formulario para conseguir tu <b>{wheelPrizes[this.state.prizeNumber].option}</b></h5>
        </Col>
      );
      result.push(
        <Col key="resultForm" xs={12}>
          <Card>
            <CardBody>
              <Row>
                <Label md={3}>¿Qué servicios te interesan?</Label>
                <Col xs={12} md={9}>
                  <FormGroup>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      placeholder="¿Qué prefieres?"
                      name="interes"
                      value={this.state.selectedInterest ? this.state.selectedInterest : null}
                      options={interestsList}
                      onChange={value =>
                        this.setState({ selectedInterest: value })
                      }
                      filterOption={this.customFilter}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Label md={3}>¿Cómo te llamas?</Label>
                <Col xs={12} sm="6">
                  <InputGroup
                    className={
                      "form-control-lg" +
                      (this.state.name
                        ? this.fullnameValidate(this.state.name)
                          ? " has-success"
                          : " has-danger"
                        : "") +
                      (this.state.nameFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons users_circle-08" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      value={this.state.name}
                      type="text"
                      placeholder="Nombre completo"
                      name="name"
                      onFocus={e => this.setState({ nameFocus: true })}
                      onBlur={e => this.setState({ nameFocus: false })}
                      onChange={e => this.onChange("name", e.target.value)}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Label md={3}>Dinos tu email 😊</Label>
                <Col xs={12} sm="6">
                  <InputGroup
                    className={
                      "form-control-lg" +
                      (this.state.email
                        ? this.emailValidate(this.state.email)
                          ? " has-success"
                          : " has-danger"
                        : "") +
                      (this.state.emailFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons ui-1_email-85" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      value={this.state.email}
                      type="email"
                      placeholder="Email"
                      name="email"
                      onFocus={e => this.setState({ emailFocus: true })}
                      onBlur={e => this.setState({ emailFocus: false })}
                      onChange={e => this.emailChange(e)}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Label md={3}>¿A qué número te podemos llamar?</Label>
                <Col xs={12} sm="6">
                  <InputGroup
                    className={
                      "form-control-lg" +
                      (this.state.mobile
                        ? this.validatePhoneNumber(this.state.mobile)
                          ? " has-success"
                          : " has-danger"
                        : "") +
                      (this.state.mobileFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons tech_mobile" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      value={this.state.mobile}
                      type="number"
                      placeholder="Móvil"
                      name="mobile"
                      onFocus={e => this.setState({ mobileFocus: true })}
                      onBlur={e => this.setState({ mobileFocus: false })}
                      onChange={e => this.mobileChange(e)}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
      if (this.state.error) {
        result.push(
          <Col key="errorInfo" xs={12} className="text-center">
            <h5 className="text-danger"><b><i className="now-ui-icons ui-1_simple-remove" /></b> {this.state.error}</h5>
          </Col>
        );
      }
      result.push(
        <Col key="submitForm" xs={12}>
          <Button 
            color="primary"
            style={{display: "block", width: "100%", fontSize: "2em"}}
            // size="sm"
            disabled={!this.validateForm() || this.state.sendingForm}
            onClick={() => { this.sendForm(); }}>
              {this.state.sendingForm ? <div><i className="now-ui-icons arrows-1_refresh-69 spin" /> Enviando...</div> : "Enviar"}
          </Button>
        </Col>
      );
    }

    return result;
  }
  getPassForm() {
    return (
      <Col key="resultForm" xs={12}>
        <Card>
          <CardBody>
            <Row>
              <Label md={3}>¿Contraseña?</Label>
              <Col xs={12}>
                <InputGroup
                  className={
                    "form-control-lg" +
                    (this.state.passFocus ? " input-group-focus" : "")
                  }
                >
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="now-ui-icons objects_key-25" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    value={this.state.pass}
                    type="password"
                    placeholder="Contraseña"
                    name="pass"
                    onFocus={e => this.setState({ passFocus: true })}
                    onBlur={e => this.setState({ passFocus: false })}
                    onChange={e => this.onChange("pass", e.target.value)}
                  />
                </InputGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  isPassCorrect(_pass) {
    return _pass === pass;
  }
  render() {
    return (
      <div>
        <PanelHeader
          size="sm"
          content={
            <div>
              {/* <h6 style={dashboardOrdersTitleStyle}>Herramientas</h6> */}
            </div>
          }
        />
        <div className="content">
          <Row>
            {this.isPassCorrect(this.state.pass) && this.getWheel()}
            {!this.isPassCorrect(this.state.pass) && this.getPassForm()}
          </Row>
        </div>
      </div>
    );
  }
}

export default Roulette;



// WEBPACK FOOTER //
// ./src/views/Roulette/Roulette.jsx